import gql from 'graphql-tag';

import { useUiQueries } from '../../lib/hooks';
import fetcher from './uiDataFetcher';

const QUERY = gql`
	query uiData_grades {
		uiData {
			grades {
				id
				name
				position
			}
		}
	}
`;

const transformer = (d) => (d.uiData.grades.toSorted((a, b) => (a.position - b.position)));

const useGrades = (nodes) => useUiQueries(
	[{
		document: QUERY,
		options: {
			queryKey: ['uiData_grades'],
			transformer: transformer,
		},
	}],
	fetcher,
)[0];
export default useGrades;
